export default __webpack_public_path__ + "static/media/tools.b561c52d.svg";